export enum NetworkNames {
    CPXRESEARCH = 'cpxresearch',
    ADGEM = 'adgem',
    WANNADS = 'wannads',
    INBRAIN = 'inbrain',
    POLLFISH = 'pollfish',
    TOROX = 'torox',
    PERSONALY = 'personaly',
    ADGATEMEDIA = 'adgate',
    AYETSTUDIOS = 'ayetstudios',
    ADSCENDMEDIA = 'adscendmedia',
    LOOTABLY = 'lootably',
    BITLABS = 'bitlabs',
    TIMEWALL = 'timewall',
}

export const NetworksForOfferwall = {
    [NetworkNames.CPXRESEARCH]: NetworkNames.CPXRESEARCH,
    [NetworkNames.ADGEM]: NetworkNames.ADGEM,
    [NetworkNames.INBRAIN]: NetworkNames.INBRAIN,
    [NetworkNames.AYETSTUDIOS]: NetworkNames.AYETSTUDIOS,
    [NetworkNames.ADGATEMEDIA]: NetworkNames.ADGATEMEDIA,
    [NetworkNames.POLLFISH]: NetworkNames.POLLFISH,
    [NetworkNames.TOROX]: NetworkNames.TOROX,
    [NetworkNames.WANNADS]: NetworkNames.WANNADS,
    [NetworkNames.LOOTABLY]: NetworkNames.LOOTABLY,
    [NetworkNames.BITLABS]: NetworkNames.BITLABS,
    [NetworkNames.TIMEWALL]: NetworkNames.TIMEWALL,
    [NetworkNames.ADSCENDMEDIA]: NetworkNames.ADSCENDMEDIA,
};
